import { render } from "./KesaktianList.vue?vue&type=template&id=6156e69e&scoped=true"
import script from "./KesaktianList.vue?vue&type=script&lang=js"
export * from "./KesaktianList.vue?vue&type=script&lang=js"

import "./KesaktianList.vue?vue&type=style&index=0&id=6156e69e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6156e69e"]])

export default __exports__